import { render, staticRenderFns } from "./OrganisationSidebarNavigation.vue?vue&type=template&id=2fbd4070&scoped=true"
import script from "./OrganisationSidebarNavigation.vue?vue&type=script&lang=ts"
export * from "./OrganisationSidebarNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd4070",
  null
  
)

export default component.exports